import { useContext } from 'react';
import { ThemeModeContext } from "../context";
export var useThemeMode = function useThemeMode() {
  return useContext(ThemeModeContext);
};